import { ArrowUpIcon } from 'components/icons';
import { Button } from 'components/ui';
import { scrollToTop } from 'utils/helpers';

export default function BackToTop() {
  return (
    <div className="flex justify-center mt-16">
      <div>
        <Button variant="normal" onClick={scrollToTop}>
          <div className="flex items-center px-4 py-2 space-x-2 text-segments-13px">
            <ArrowUpIcon className="w-4 h-4 text-black" />
            <p>BACK TO TOP</p>
          </div>
        </Button>
      </div>
    </div>
  );
}
